//#region IMPORT
import React, { useState, useEffect } from 'react';
import { useAppNavigate } from '../../../Hooks/back/useAppNavigate';
import { useDispatch, useSelector } from 'react-redux';
import { NavBarInfoActions } from '../../../Reducer/NavBarInfoReducer';
import { showSnackbar } from '../../../Reducer/SnackbarReducer';
import { CommonActions } from '../../../Reducer/CommonReducer';
import { BottomSheetActions } from '../../../Reducer/BottomSheetReducer';
import M_WOE_BASIC_01 from './M_WOE_BASIC_01';
import { useSave1 } from './M_WOE_BASIC_01_Query';
import { useSave } from '../../../Hooks/useSave';
import useFileUpload from '../../../Hooks/useFileUpload';
import { WOE_BASIC_01_Schema } from './M_WOE_BASIC_01_Schema';
import { useBackStack } from '../../../Hooks/back/useBackStack';
//#endregion

const INPUTS = {
  beforeComment: '',
};

function M_WOE_BASIC_01F() {
  const { navigate } = useAppNavigate();
  const dispatch = useDispatch();
  const { userInfo } = useSelector((state) => state.BaseInfo);
  const workCd = useSelector((state) => state.workingCheck.workCd);
  const bottomSheetState = useSelector((state) => state.bottomSheet);
  const [workEndInputs, setWorkEndInputs] = useState(INPUTS);
  const [errors, setErrors] = useState({});

  const workEndUpload = useFileUpload({
    oldFilePathField: 'image',
    newFileNameField: 'saveName',
    maxCount: 5,
    getTargetPath: () =>
      `WorkEnd/${userInfo.custCd}/WOE_BASIC_01/${userInfo.depCd}`,
  });

  useEffect(() => {
    Init();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // 스택형 뒤로가기로 변경: 작업 종료 작성 중 이탈 시 확인 시트 표시
  useBackStack({
    type: 'sheet',
    enabled: !bottomSheetState.bottom,
    onBack: () =>
      dispatch(BottomSheetActions.OpenBottomSheet({ type: 'backClickWor' })),
  });

  const Init = () => {
    dispatch(NavBarInfoActions.setType('titleBar'));
    dispatch(NavBarInfoActions.setTitleName('작업 종료'));
    dispatch(CommonActions.setActiveStep(0));
  };

  //#region 쿼리
  const { runAsync: Save1Async } = useSave1();
  //#endregion

  //#region 저장
  const { run: Save1 } = useSave({
    menuId: 'M_WOE_BASIC_01',
    schema: WOE_BASIC_01_Schema,
    saveData: () => ({
      workCd,
      depCd: userInfo.depCd,
      beforeComment: workEndInputs.beforeComment ?? '',
      beforeImage: '',
    }),
    fileSave: async () => {
      const beforeImage = await workEndUpload.SaveLogicFile();
      return { beforeImage: beforeImage || '' };
    },
    requestSave: async (rows) => {
      const row = rows[0] ?? {};
      const res = await Save1Async({
        row: { ...row, beforeImage: '' },
        userInfo,
      });
      const workCdResult = res?.[0]?.workCd ?? res?.workCd;
      if (!workCdResult) return res;

      let beforeImage = '';
      if (workEndUpload.previewList.filter((img) => !img.deleted).length > 0) {
        beforeImage = (await workEndUpload.SaveLogicFile()) || '';
        await Save1Async({
          row: {
            ...row,
            workCd: workCdResult,
            beforeImage,
          },
          userInfo,
        });
      }

      dispatch(showSnackbar({ message: '저장 완료', type: 'success' }));
      navigate('/Home');
      return res;
    },
  });
  //#endregion

  return (
    <div className="wrap">
      <M_WOE_BASIC_01
        userInfo={userInfo}
        workEndInputs={workEndInputs}
        setWorkEndInputs={setWorkEndInputs}
        previewList={workEndUpload.previewList}
        errors={errors}
        setErrors={setErrors}
        FileChange={workEndUpload.FileChange}
        SaveLogic1={Save1}
        DeletePreview={workEndUpload.DeletePreview}
        ValidateAll={() => {
          const requiredFields = ['beforeComment'];
          let newErrors = {};
          let hasError = false;
          requiredFields.forEach((field) => {
            const msg =
              (workEndInputs[field] || '').trim() === ''
                ? `${field}를 입력하세요.`
                : '';
            newErrors[field] = msg;
            if (msg) hasError = true;
          });
          setErrors(newErrors);
          return !hasError;
        }}
      />
    </div>
  );
}

export default M_WOE_BASIC_01F;
